// libraries
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// auth
import Eligibility from '../components';
import {
  getCountries,
  getCities,
  getSchools
} from '../actions/eligibility';
import {
  saveUrlParameters
} from '../../shared/actions/url-parameters';

// shared
import {
  setNavigationAnnouncement
} from 'shared/actions/accessibility-announcement';

const mapStateToProps = ({countries, cities, schools}) => ({
  countries, cities, schools
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    getCountries,
    getCities,
    getSchools,
    setNavigationAnnouncement,
    saveUrlParameters
  }, dispatch)
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Eligibility);
